import { useState, useRef, useEffect } from "react";
import { Tooltip } from "react-tooltip";

export default function TextWithTip(props: {
	uniqueName: string;
	text: string | undefined;
	tooltipText?: string;
	forceTooltip?: boolean;
	tooltipClass?: string;
}) {
	const [showTooltip, setShowTooltip] = useState(false);
	const textRef = useRef<HTMLDivElement>(null);
	const text = props.text ?? "unknown";
	const tooltipContent = props.tooltipText ?? text;
	const id = `${props.uniqueName}-tooltip`;

	const compareSize = () => {
		if (textRef.current) {
			const showTooltip =
				textRef.current.scrollWidth > textRef.current.clientWidth ||
				textRef.current.scrollHeight > textRef.current.clientHeight;
			setShowTooltip(showTooltip);
		}
	};

	// compare once and add/remove resize listener
	useEffect(() => {
		compareSize();
		window.addEventListener("resize", compareSize);
		return () => {
			window.removeEventListener("resize", compareSize);
		};
	}, []);

	return (
		<div className="group">
			<span
				ref={textRef}
				className="whitespace-nowrap text-ellipsis overflow-hidden block"
				data-tooltip-id={`${id}`}>
				{text}
			</span>
			{(showTooltip || props.forceTooltip) && (
				<Tooltip
					id={`${id}`}
					place="top-start"
					className={`${props.tooltipClass} !text-sm font-normal z-50`}
					content={tooltipContent}
				/>
			)}
		</div>
	);
}
